<template>
  <v-expansion-panel popout lazy>
    <v-expansion-panel-content :value="value" @input="$emit('input', $event.target.value)" class>
      <v-container>
        <v-layout row wrap v-if="!!data">
          <v-flex xs12>
            <div class="vertical-center-container">
              <v-icon :color="routeProps.color" class="mr-3" large>{{routeProps.icon}}</v-icon>
              <span class="title grey--text text--darken-1">{{data.name}}</span>
            </div>
          </v-flex>
          <v-flex sm6 lg4 xs12>
            <template v-if="!!data.contactEmail || !!data.contactPhone">
              <v-divider></v-divider>
              <v-list>
                <v-list-tile v-if="!!data.contactEmail" :href="'mailto:'+data.contactEmail">
                  <v-list-tile-action>
                    <v-icon>mail</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class>{{data.contactEmail}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-if="!!data.contactPhone" :href="'tel:'+data.contactPhone">
                  <v-list-tile-action>
                    <v-icon>phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class>
                    <v-list-tile-title class>{{data.contactPhone}}</v-list-tile-title>
                    <v-list-tile-sub-title></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile v-if="route == 'project'">
                  <v-list-tile-action>
                    <v-icon
                      v-if="data.active"
                      :color="data.active ? 'green lighten-3' : 'red lighten-3'"
                    >check_circle</v-icon>
                    <v-icon
                      v-else
                      :color="data.active ? 'green lighten-3' : 'red lighten-3'"
                    >highlight_off</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class>
                    <v-list-tile-title class>{{data.active ? "Active" : "In-active project"}}</v-list-tile-title>
                    <v-list-tile-sub-title></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider></v-divider>
            </template>
            <div class="card-footer text-xs-left pl-0 pt-3">
              <time-ago
                class="grey--text"
                :time="data.updatedAt"
                needsParse
                updated
                :createdTime="data.createdAt"
              >
                <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
              </time-ago>
            </div>
          </v-flex>
          <v-flex sm4 xs12></v-flex>
          <v-flex sm4 xs12></v-flex>
        </v-layout>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  data() {
    return {
      routeProps: this.$store.state.global.pages[this.route]
    };
  },
  props: {
    data: Object,
    route: String,
    value: Boolean
  }
};
</script>

<style>
</style>
